import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';

export function SettingsLayoutBackToWorkspace() {
    return (
        <Button asChild variant="ghost" size="lg" className="has-[>svg]:px-2 sm:has-[>svg]:px-6">
            <Link to="/dashboard">
                <ArrowLeft />
                Back to Workspace
            </Link>
        </Button>
    );
}
